import { AuctionsNearMeCardsViewNew } from './components/MapView/components/CardsView/AuctionsNearMeCardsViewNew';
import { AuctionsNearMeMapViewNew } from './components/MapView/AuctionsNearMeMapViewNew';
import { AuctionsNearMeRouteParams } from './types/AuctionsNearMe.types';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { getPageDescriptionFromGeoArea } from './helpers/getPageDescription';
import { getPageTitle } from './helpers/getPageTitle';
import { LeaderBoardAdTypes } from '@/redux/modules/catalog/ad/catalogAd.types';
import { ReactElement } from 'react';
import { useAuctionsNearMeData } from './hooks/useAuctionsNearMeData';
import { useParams } from 'react-router-dom';
import AuctionsNearMePageMeta from './meta/AuctionsNearMePageMeta';
import CategoryAd from '@/components/Ads/CategoryAd';
import PageTitle from '@/components/PageTitle/PageTitle';

const AuctionsNearMePageNew = (): ReactElement => {
    const routeParams = useParams<AuctionsNearMeRouteParams>();

    const adId = 'auctions-near-me';
    const adPageName = `leaderboard-${adId}`;

    const {
        catalogsNearMe,
        geoArea,
        geocoderFailed,
        handleBoundsChange,
        handleGoogleMapsReady,
        handleSearchResults,
        hasFilteredResults,
        isGeocoding,
        mapBounds,
        searchTerm,
        setGeocoderFailed,
        setSearchTerm,
    } = useAuctionsNearMeData();

    return (
        <>
            <CategoryAd
                adType={LeaderBoardAdTypes[adId]}
                pageName={adPageName}
            />
            <AuctionsNearMePageMeta
                catalogsNearMe={catalogsNearMe}
                geoArea={geoArea}
                routeParams={routeParams}
                searchTerm={searchTerm}
            />
            <section className="relative mx-auto flex min-h-[400px] w-full max-w-[1240px] flex-col px-md pb-xl pt-0">
                {/* Page Title and Description */}
                <section className="mb-lg">
                    <div className="mb-xs flex w-full justify-between">
                        <PageTitle
                            title={getPageTitle({
                                geoArea,
                                geocoderFailed,
                                hasFilteredResults,
                                routeParams,
                                searchTerm,
                            })}
                        />
                    </div>
                    <div className="max-w-[590px]">
                        <BodySecondary color="secondary">{getPageDescriptionFromGeoArea(geoArea)}</BodySecondary>
                    </div>
                </section>
                {/* Split container  */}
                <section className="mb-sm flex flex-col-reverse smMin:flex-row">
                    {/* CardsView */}
                    <div className="flex-[1_1_calc(100%-590px)] smMin:mr-md">
                        <AuctionsNearMeCardsViewNew
                            catalogsNearMe={catalogsNearMe}
                            geoArea={geoArea}
                        />
                    </div>
                    {/* MapView */}
                    <div className="mb-xs flex-[1_1_calc(100%-590px)] smMin:sticky smMin:top-lg smMin:mb-0 smMin:mt-lg smMin:h-fit">
                        <AuctionsNearMeMapViewNew
                            catalogsNearMe={catalogsNearMe}
                            geoArea={geoArea}
                            isGeocoding={isGeocoding}
                            mapBounds={mapBounds}
                            onBoundsChange={handleBoundsChange}
                            onGoogleMapsReady={handleGoogleMapsReady}
                            onSearchResults={handleSearchResults}
                            parentSearchTerm={searchTerm}
                            setGeocoderFailed={setGeocoderFailed}
                            setSearchTerm={setSearchTerm}
                        />
                    </div>
                </section>
            </section>
        </>
    );
};

export default AuctionsNearMePageNew;
